import { ApplicationHelpType, FavoriteTypesEnum, SortDirections } from '../../../../utilities/Constants';
import { CaseResolutionCurrentStepEnum, CaseResolutionQScoreEnum, CaseResolutionSortColumns, ICaseResolutionSearchModel } from '../../case-resolution-admin/useGetCaseResolutionQuery';
import { Container, Offcanvas, Stack, Table } from 'react-bootstrap';
import { useEffect, useRef, useState } from 'react';

import { CaseResolutionFilter } from '../../../../components/quad/case-resolution/CaseResolutionFilter';
import { CheckmatePagination } from '../../CheckmatePagination';
import Common from '../../../../stores/Common';
import { DocumentTitle } from '../../../../components/shared/DocumentTitle';
import { Favorite } from '../../../../components/shared/Favorite';
import { Help } from '../../../../components/shared/Help';
import { ICaseResolutionModel } from '../../../../interfaces/ICaseResolutionModel';
import { IMultiSelectOption } from '../../../../interfaces/ILookup';
import { IPagedSortedSearchResponseModel } from '../../../../interfaces/PagedSortedSearch';
import { Link } from 'react-router-dom';
import { Loader } from '../../../../components/shared/Loader';
import { NoResultsDisplay } from '../../../../components/quad/same-cases-admin/NoResultsDisplay';
import { PageWithAffixedHeader } from '../../../../shared/PageWithAffixedHeader';
import { SortableHeader } from '../../../../components/shared/SortableHeader';
import classNames from 'classnames';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { useDidUpdate } from '@mantine/hooks';
import { useGetViewCaseResolution } from './useGetViewCaseResolution';
import { useSetCasePinned } from '../../case-resolution-admin/useSetCasePinned';
import { useSetCaseUnpinned } from '../../case-resolution-admin/useSetCaseUnpinned';
import { useZoneContext } from '../../../../contexts/useZoneContext';
import { useZoneUsers } from '../../../../shared/react-query-hooks/useZoneUsers';
import { ApiRoutes } from '../../../../utilities/ApiRoutes';


const pageTitle = 'Case Resolution';


export function ViewCaseResolutionPage() {
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();
    const { zoneApiClient } = useZoneContext();
    //const zoneUsersApi = useZoneUsers(zoneApiClient); // AR - TO DO - After 6.1.0
    const searchMutation = useGetViewCaseResolution();
    const setPinned = useSetCasePinned();
    const setUnpinned = useSetCaseUnpinned();

    const [showFilterPane, setShowFilterPane] = useState<boolean>(false);
    const [hover, setHover] = useState<number | null>(null);
    const [currentFilters, setCurrentFilters] = useState<ICaseResolutionSearchModel>({
        pagedModel: {
            pageNumber: 1,
            pageSize: 10,
        },
        sortModel: {
            sortColumn: CaseResolutionSortColumns.CaseName,
            sortDirection: SortDirections.Asc,
        },
    });
    const [results, setResults] = useState<IPagedSortedSearchResponseModel<ICaseResolutionModel, undefined>>();

    //For Favorites
    const currentStepOptions = Object.values(CaseResolutionCurrentStepEnum) as IMultiSelectOption[]
    const qScoreOptions = Object.values(CaseResolutionQScoreEnum) as IMultiSelectOption[]
    const [jurisdictionsOptions, setJurisdictionsOptions] = useState<IMultiSelectOption[]>();
    const [usStatesOptions, setUsStatesOptions] = useState<IMultiSelectOption[]>();
    const [caseManagerOptions, setCaseManagerOptions] = useState<IMultiSelectOption[]>();
    const [plaintiffFirmOptions, setPlaintiffFirmOptions] = useState<IMultiSelectOption[]>();
    const [nationalPlaintiffFirmOptions, setNationalPlaintiffFirmOptions] = useState<IMultiSelectOption[]>();
    const [zoneOptions, setZoneOptions] = useState<IMultiSelectOption[]>();


    const [currentFavoriteDetailsString, setCurrentFavoriteDetailsString] = useState<string>('');
    // const zoneUsers = zoneUsersApi.data || []; // AR - TO DO - After 6.1.0
    const [exportResponse, setExportResponse] = useState<boolean>(true);
    const lastAppliedFiltersRef = useRef<ICaseResolutionSearchModel | null>(null);


    const [showOverlayMask] = useState<boolean>(true);

    const hasRows = true;

    const togglePinned = (caseResolutionCase: ICaseResolutionModel) => {
        if (!caseResolutionCase.pinned) {
            setPinned
                .mutateAsync(caseResolutionCase)
                    .catch((error) => alert(error));
        }
        else {
            setUnpinned
                .mutateAsync(caseResolutionCase)
                    .catch((error) => alert(error));
        }
        caseResolutionCase.pinned = !caseResolutionCase.pinned;
    }

    const handleSortData = (key: string, order: string) => {
        const sortColumn = CaseResolutionSortColumns[key as keyof typeof CaseResolutionSortColumns] ?? CaseResolutionSortColumns.CaseName;
        const sortDirection =
            order.toUpperCase() === 'DESC' ? SortDirections.Desc : SortDirections.Asc;

        if (
            sortColumn === currentFilters.sortModel.sortColumn &&
            sortDirection === currentFilters.sortModel.sortDirection
        ) {
            return;
        }

        setCurrentFilters((prev) => ({
            ...prev,
            pagedModel: { ...prev.pagedModel, pageNumber: 1 },
            sortModel: {
                sortColumn,
                sortDirection,
            },
        }));
    };

    //Favorite
    const updateData = (settingJson: string, isDefault?: boolean) => {
        const currentCaseSearchParameterString = JSON.stringify(settingJson);
        if (currentCaseSearchParameterString.trim() === settingJson.trim()) return;

        const caseSearchParameters: ICaseResolutionSearchModel = JSON.parse(settingJson);
        setCurrentFilters((prev) => ({...prev, caseSearchParameters }))

        filterSearch(caseSearchParameters)
    };

    const handleFavoriteSelected = (settingJson?: string) => {
        let selectedFilters = '';
        if (settingJson) {
            const caseSearchParameters: ICaseResolutionSearchModel = JSON.parse(settingJson);

            if (caseSearchParameters) {
                if (caseSearchParameters.states && caseSearchParameters.states.length > 0) {
                    selectedFilters += 'STATE:' + '\n';
                    for (let i = 0; i < caseSearchParameters.states.length; i++) {
                        const match = usStatesOptions?.filter(
                            (x) => x.value == caseSearchParameters.states![i]
                        );
                        if (match && match.length > 0) {
                            selectedFilters += match[0].label + '\n';
                        }
                    }
                    selectedFilters += '\n';
                }
                }
            if (caseSearchParameters) {
                if (caseSearchParameters.jurisdiction && caseSearchParameters.jurisdiction.length > 0) {
                    selectedFilters += 'JURISDICTION:' + '\n';
                    for (let i = 0; i < caseSearchParameters.jurisdiction.length; i++) {
                        const match = jurisdictionsOptions?.filter(
                            (x) => x.value == caseSearchParameters.jurisdiction![i]
                        );
                        if (match && match.length > 0) {
                            selectedFilters += match[0].label + '\n';
                        }
                    }
                    selectedFilters += '\n';
                }
                }
            if (caseSearchParameters) {
                if (caseSearchParameters.caseManagerId && caseSearchParameters.caseManagerId.length > 0) {
                    selectedFilters += 'A1:' + '\n';
                    for (let i = 0; i < caseSearchParameters.caseManagerId.length; i++) {
                        const match = caseManagerOptions?.filter(
                            (x) => x.value == caseSearchParameters.caseManagerId![i]
                        );
                        if (match && match.length > 0) {
                            selectedFilters += match[0].label + '\n';
                        }
                    }
                    selectedFilters += '\n';
                }
                }
            if (caseSearchParameters) {
                if (caseSearchParameters.plaintiffsFirm && caseSearchParameters.plaintiffsFirm.length > 0) {
                    selectedFilters += 'PLAINTIFFS FIRM:' + '\n';
                    for (let i = 0; i < caseSearchParameters.plaintiffsFirm.length; i++) {
                        const match = plaintiffFirmOptions?.filter(
                            (x) => x.value == caseSearchParameters.plaintiffsFirm![i]
                        );
                        if (match && match.length > 0) {
                            selectedFilters += match[0].label + '\n';
                        }
                    }
                    selectedFilters += '\n';
                }
                }
            if (caseSearchParameters) {
                if (caseSearchParameters.nationalPlaintiffsFirm && caseSearchParameters.nationalPlaintiffsFirm.length > 0) {
                    selectedFilters += 'NATIONAL PLAINTIFFS FIRM:' + '\n';
                    for (let i = 0; i < caseSearchParameters.nationalPlaintiffsFirm.length; i++) {
                        const match = nationalPlaintiffFirmOptions?.filter(
                            (x) => x.value == caseSearchParameters.nationalPlaintiffsFirm![i]
                        );
                        if (match && match.length > 0) {
                            selectedFilters += match[0].label + '\n';
                        }
                    }
                    selectedFilters += '\n';
                }
                }
            if (caseSearchParameters) {
                if (caseSearchParameters.qScore && caseSearchParameters.qScore.length > 0) {
                    selectedFilters += 'SQ SCORE:' + '\n';
                    for (let i = 0; i < caseSearchParameters.qScore.length; i++) {
                        const match = qScoreOptions?.filter(
                            (x) => x.value == caseSearchParameters.states![i]
                        );
                        if (match && match.length > 0) {
                            selectedFilters += match[0].label + '\n';
                        }
                    }
                    selectedFilters += '\n';
                }
                }
            if (caseSearchParameters) {
                if (caseSearchParameters.currentStep && caseSearchParameters.currentStep.length > 0) {
                    selectedFilters += 'CURRENT STEP:' + '\n';
                    for (let i = 0; i < caseSearchParameters.currentStep.length; i++) {
                        const match = currentStepOptions?.filter(
                            (x) => x.value == caseSearchParameters.currentStep![i]
                        );
                        if (match && match.length > 0) {
                            selectedFilters += match[0].label + '\n';
                        }
                    }
                    selectedFilters += '\n';
                }
            }
            if (caseSearchParameters) {
                if (caseSearchParameters.zoneId && caseSearchParameters.zoneId.length > 0) {
                    selectedFilters += 'ZONE:' + '\n';
                    for (let i = 0; i < caseSearchParameters.zoneId.length; i++) {
                        const match = zoneOptions?.filter(
                            (x) => x.value == caseSearchParameters.zoneId![i]
                        );
                        if (match && match.length > 0) {
                            selectedFilters += match[0].label + '\n';
                        }
                    }
                    selectedFilters += '\n';
                }
            }
        setCurrentFavoriteDetailsString(selectedFilters);
        }
    }

    const getCaseStep = (caseResolutionCase: ICaseResolutionModel) => {
        if (!caseResolutionCase.steps) return;
        if (caseResolutionCase.completedDate) return 'Complete'

        const caseCurrentStep = caseResolutionCase?.steps.find((x) => x.isActive);
        return caseCurrentStep?.name ?? "";
    }

    // AR - TO DO - After 6.1.0
/*     const getAssignedUser = (caseResolutionCase: ICaseResolutionModel) => {
        if (!caseResolutionCase) return;
        const caseCurrentStep = caseResolutionCase?.steps.find((x) => x.isActive);
        if (caseResolutionCase.completedDate) return '';
        if (!caseCurrentStep) return;

        const assignedUser = zoneUsers.find((x) => x.guid === caseCurrentStep.userId);
        if (!assignedUser) return null;

        return assignedUser?.profile?.firstName + " " + assignedUser?.profile?.lastName;
    } */

    //pure + safe
    const namesToGuids = (filter: ICaseResolutionSearchModel): ICaseResolutionSearchModel => {
        return {
            ...filter,
            states: filter.states?.length
                ? usStatesOptions?.filter(x => filter.states!.includes(x.value)).map(x => x.guid!)
                : undefined,

            jurisdiction: filter.jurisdiction?.length
                ? jurisdictionsOptions?.filter(x => filter.jurisdiction!.includes(x.value)).map(x => x.guid!)
                : undefined,

            plaintiffsFirm: filter.plaintiffsFirm?.length
                ? plaintiffFirmOptions?.filter(x => filter.plaintiffsFirm!.includes(x.value)).map(x => x.guid!)
                : undefined,

            nationalPlaintiffsFirm: filter.nationalPlaintiffsFirm?.length
                ? nationalPlaintiffFirmOptions?.filter(x => filter.nationalPlaintiffsFirm!.includes(x.value)).map(x => x.guid!)
                : undefined,
        };
    };



    const applyFavoriteSelected = (settingJson?: string) => {
        if (settingJson) {
            updateData(settingJson);
        }
    };

    const filterSearch = (filter: ICaseResolutionSearchModel) => {
        const finalFilter = namesToGuids(filter);
        lastAppliedFiltersRef.current = filter;
        searchMutation
            .mutateAsync(filter)
            .then((searchResults) => {
                setCurrentFilters(finalFilter);
                setResults(searchResults);

                if (showOverlayMask) {
                    setShowFilterPane(false);
                }
            })
            .catch((error) => alert(error));
            
    };

    const handleApplyFilters = (
        filters: ICaseResolutionSearchModel,
        stateOptions: IMultiSelectOption[],
        jurisdictionOptions: IMultiSelectOption[],
        caseManagerOptions: IMultiSelectOption[],
        plaintiffFirmOptions: IMultiSelectOption[],
        nationalPlaintiffFirmOptions: IMultiSelectOption[],
        zoneOptions: IMultiSelectOption[]
    ) => {
        setUsStatesOptions(stateOptions);
        setJurisdictionsOptions(jurisdictionOptions);
        setCaseManagerOptions(caseManagerOptions);
        setPlaintiffFirmOptions(plaintiffFirmOptions);
        setNationalPlaintiffFirmOptions(nationalPlaintiffFirmOptions);
        setZoneOptions(zoneOptions);

        filterSearch(filters);
    };


    const handleToggleFilterPane = () => {
        setShowFilterPane(prev => !prev);
    };

    const handlePageChange = (pageNumber: number) => {
        setCurrentFilters((prev) => ({ ...prev, pagedModel: { ...prev.pagedModel, pageNumber } }));
    };

    const getRatingColor = (step: any) => {       

        if (!step?.stepData?.ratings?.[0]) return '#e4e5e9';
        const value = step?.stepData?.ratings?.[0]?.value;
        if (value === 1) {
            return '#ff0000';
        }
        if (value === 2) {
            return '#f7b730';
        }
        if (value === 3) {
            return '#4abdac';
        }
        return '#e4e5e9';
    }

    const handlePageSizeChange = (pageSize: number) => {
        setCurrentFilters((prev) => ({
            ...prev,
            pagedModel: { ...prev.pagedModel, pageSize, pageNumber: 1 },
        }));
    };

    useDidUpdate(() => {
        searchMutation.mutateAsync(currentFilters).then((searchresults) => {
            setResults(searchresults);
        });
    }, [
        currentFilters.pagedModel.pageSize,
        currentFilters.pagedModel.pageNumber,
        currentFilters.sortModel.sortColumn,
        currentFilters.sortModel.sortDirection,
    ]);

    useEffect(() => {
        searchMutation.mutateAsync(currentFilters).then((searchresults) => {
            setResults(searchresults);
        });
    }, []);

    const exportCaseResolutions = async () => {
            setExportResponse(true);
            const exportFilters = lastAppliedFiltersRef.current ?? currentFilters;
            const xhr = new XMLHttpRequest();
            xhr.open('POST', '/' + ApiRoutes.CaseResolutionExport, true);
            xhr.responseType = 'blob';
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('X-Tenant-Guid', zoneContext.zoneGuid);
            
            xhr.onreadystatechange = () => {
                if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                    setExportResponse(false);
    
                    let fileName = 'CaseResolutions.xlsx';
                    const blob = xhr.response;
    
                    const contentDisposition = xhr.getResponseHeader('Content-Disposition');
                    if (contentDisposition) {
                        const contentDispositionItems = contentDisposition.split(';');
                        if (contentDispositionItems) {
                            for (let i = 0; i < contentDispositionItems.length; i++) {
                                const currentItem = contentDispositionItems[i];
                                if (currentItem.includes('filename=')) {
                                    const n = currentItem.indexOf('filename=') + 9;
                                    fileName = contentDispositionItems[i].substring(
                                        n + 1,
                                        contentDispositionItems[i].length - 1
                                    );
                                    break;
                                }
                            }
                        }
                    }
                    const a = document.createElement('a');
                    a.href = window.URL.createObjectURL(blob);
                    a.download = fileName;
                    a.dispatchEvent(new MouseEvent('click'));
                }
    
                if (xhr.readyState === XMLHttpRequest.DONE && xhr.status >= 400) {
                    setExportResponse(false);
                    //todo handle error.
                    // if (typeof props.handleError === 'function') {
                    //     this.props.handleError();
                    // }
                }
            };
            const parm = exportFilters;
            xhr.send(JSON.stringify(parm));
    };

    return (
        <>
            <DocumentTitle title={`Quad - ${pageTitle}`} hideZoneName />
            {searchMutation.isLoading && <Loader />}
            <Offcanvas
                show={showFilterPane}
                onHide={() => setShowFilterPane(false)}
                placement="end"
                //scroll
                backdrop
                style = {{ width: '450px'  }}
            >
                <Offcanvas.Header
                    closeButton
                    style={{ borderBottom: '1px solid lightgray', height: '77px' }}
                >
                    <Offcanvas.Title>
                        <span style={{ fontSize: 20, fontWeight: 500 }}>{pageTitle} Filters</span>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <CaseResolutionFilter
                        currentFilters={currentFilters}
                        expanded={showFilterPane}
                        onApplyFilters={handleApplyFilters}
                        onToggleFilterPane={handleToggleFilterPane}
                    />
                </Offcanvas.Body>
            </Offcanvas>

            <PageWithAffixedHeader
                hideHeaderBottomPadding
                headerComponent={
                    <>
                        <h1 style={{ margin: 0 }} className="mb-2">
                            {pageTitle}
                            <button
                                className="btn btn-no-bg float-end text-gray horizontal-margin-right-lg"
                                onClick={exportCaseResolutions}
                            >
                                <i className="fal fa-file-export" />
                                &nbsp;Export
                            </button>
                <Favorite
                    user={user}
                    type={{ id: FavoriteTypesEnum.CaseResolution }}
                    currentFavoriteSettingJson={JSON.stringify(
                        currentFilters
                        )}
                    currentFavoriteDetailsString={currentFavoriteDetailsString}
                    onFavoriteSelected={handleFavoriteSelected}
                    applyFavoriteSelected={applyFavoriteSelected}
                    onDefaultFavoriteChange={applyFavoriteSelected}
                    zoneContext={zoneContext}
                />
                        </h1>

                        <Stack direction="horizontal" gap={2}>
                            <button
                                className="btn btn-no-bg"
                                onClick={handleToggleFilterPane}
                                style={{ marginLeft: -12 }}
                            >
                                <Stack direction="horizontal" gap={1}>
                                    <i className="fal fa-filter" />
                                    <span>Filters</span>
                                </Stack>
                            </button>
                        </Stack>

                        {!!searchMutation.isError && (
                            <div className="text-danger">
                                <p>{(searchMutation.error as Error).message}</p>
                            </div>
                        )}
                    </>
                }
            >
                <Table>
                    <thead>
                        <tr>
                            <SortableHeader
                                headerText="Zone"
                                sortKey="Zone"
                                onSort={handleSortData}
                                noWrap
                            />
                            <SortableHeader
                                headerText="Case Name"
                                sortKey="CaseName"
                                onSort={handleSortData}
                                noWrap
                            />
                            <SortableHeader
                                headerText="Jurisdiction"
                                sortKey="Jurisdiction"
                                onSort={handleSortData}
                                noWrap
                            />
                            <SortableHeader
                                headerText="Plaintiff"
                                sortKey="Plaintiff"
                                onSort={handleSortData}
                                noWrap
                            />
                            <SortableHeader
                                headerText="National Plaintiff"
                                sortKey="NationalPlaintiff"
                                onSort={handleSortData}
                                noWrap
                            />
                            <SortableHeader
                                headerText="Current Step"
                                sortKey="CurrentStep"
                                onSort={handleSortData}
                                noWrap
                            />
                            <SortableHeader
                                headerText="Assigned"
                                sortKey="Assigned"
                                onSort={handleSortData}
                                noWrap
                            />
                            <th className={classNames('sortable-header')}>
                                <div>
                                    <span>
                                        Ratings
                                    </span>
                                            <Help
                                                type={ApplicationHelpType.Info}
                                                title={"A1"}
                                                helpText={"Rating for Admin QC, Legal QC and Final Review"}
                                            />
                                            
                                </div>
                            </th>
                            <SortableHeader
                                headerText="SQ Score"
                                sortKey="SqScore"
                                onSort={handleSortData}
                                noWrap
                            />
                            <SortableHeader
                                headerText="Trial Date"
                                sortKey="TrialDate"
                                onSort={handleSortData}
                                noWrap
                            />
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {results?.results?.map((caseResolution: ICaseResolutionModel, index: number) => (
                            <tr 
                            onMouseEnter={() => setHover(index)}
                            onMouseLeave={() => setHover(null)}
                            key={caseResolution.id} style={{ 
                                verticalAlign: 'middle', 
                                backgroundColor: hover === index ? '#f5f5f5' : '',
                                transition: 'background-color 0.1s ease',
                                width: '100%'
                                }}>
                                <td>
                                    <a href={`/zone/${caseResolution.zoneId}/caseresolution/${caseResolution.id}/case/${caseResolution.caseId}`} className="row-link">
                                    <MaskableValue
                                        value={caseResolution.zoneName}
                                        width={100}
                                    />
                                    </a>
                                </td>
   
                                <td>
                                    <Link
                                        to={caseResolution.caseUrl}
                                        target="_blank"
                                    >
                                    <MaskableValue
                                        value={caseResolution.caseName}
                                        width={100}
                                    />
                                    </Link>
                                </td>
                                <td>
                                    <a href={`/zone/${caseResolution.zoneId}/caseresolution/${caseResolution.id}/case/${caseResolution.caseId}`} className="row-link">
                                    <MaskableValue
                                        value={caseResolution.jurisdiction}
                                        width={100}
                                    />
                                    </a>
                                </td>
                                <td>
                                    <a href={`/zone/${caseResolution.zoneId}/caseresolution/${caseResolution.id}/case/${caseResolution.caseId}`} className="row-link">
                                    <MaskableValue
                                        value={caseResolution.plaintiffsFirm}
                                        width={100}
                                    />
                                    </a>
                                </td>
                                <td>
                                    <a href={`/zone/${caseResolution.zoneId}/caseresolution/${caseResolution.id}/case/${caseResolution.caseId}`} className="row-link">
                                    <MaskableValue
                                        value={caseResolution.secondaryPlaintiffsFirm}
                                        width={100}
                                    />
                                    </a>
                                </td>
                                <td>
                                    <a href={`/zone/${caseResolution.zoneId}/caseresolution/${caseResolution.id}/case/${caseResolution.caseId}`} className="row-link">
                                    <MaskableValue
                                        value={getCaseStep(caseResolution) ?? "Complete"}
                                        width={100}
                                    />
                                    </a>
                                </td>
                                <td>
                                    <a href={`/zone/${caseResolution.zoneId}/caseresolution/${caseResolution.id}/case/${caseResolution.caseId}`} className="row-link">
                                    TO DO - After 6.1.0
{/*                                     <MaskableValue
                                        value={getAssignedUser(caseResolution) ?? "Unassigned"}
                                        width={100}
                                    /> */}
                                    </a>
                                </td>
                                <td>
                                    <a href={`/zone/${caseResolution.zoneId}/caseresolution/${caseResolution.id}/case/${caseResolution.caseId}`} className="row-link">
                                        <Container className="d-flex justify-content-center align-items-center gap-1 py-2">
                                            {[3, 4, 5].map((star) => (
                                                <button className="btn" 
                                                style={{ border: 'none', padding: 0, fontSize: '1.2rem'}}
                                                key={star}
                                                >
                                                    <i className={'fa-solid fa-circle'} 
                                                    style={{ color: getRatingColor(caseResolution.steps[star])}}
                                                    ></i>
                                                </button>
                                            ))}
                                        </Container>
                                    </a>
                                </td>
                                <td>
                                    <a href={`/zone/${caseResolution.zoneId}/caseresolution/${caseResolution.id}/case/${caseResolution.caseId}`} className="row-link">
                                    <MaskableValue
                                        value={caseResolution.qScore.toString()}
                                        width={100}
                                    />
                                    </a>
                                </td>
                                <td>
                                    <a href={`/zone/${caseResolution.zoneId}/caseresolution/${caseResolution.id}/case/${caseResolution.caseId}`} className="row-link">
                                    <MaskableValue
                                        value={Common.dateFormat(caseResolution.trialDate)}
                                        width={80}
                                    />
                                    </a>
                                </td>
                                <td>
                        <button
                            className="btn btn-no-bg"
                            onClick={() => {
                                togglePinned(caseResolution);
                            }}
                        >
                            <i className={`pin ${caseResolution.pinned ? "pinned" : "unpinned"}`} />
                        </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                <NoResultsDisplay
                    onShowFiltersClick={handleToggleFilterPane}
                    show={!hasRows && !searchMutation.isLoading}
                />

                <CheckmatePagination
                    pagedModel={results?.pagedModel}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                    hidePageSizeSelector
                />
            </PageWithAffixedHeader>
        </>
    );
}

const MaskableValue = (props: { value: string; width?: number }) => {
    return (
        <div style={{ paddingRight: '2em' }}>
                {props.value}
        </div>
    );
};